import { HomeView } from './home/home.view';

export function HomeScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <HomeView />
    </div>
  );
}
